/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_List_ViewInputs */

const en_doc_list_view = /** @type {(inputs: Doc_List_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const pt_br2_doc_list_view = /** @type {(inputs: Doc_List_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizar`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Doc_List_ViewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_list_view = /** @type {((inputs?: Doc_List_ViewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_List_ViewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_list_view(inputs)
	return pt_br2_doc_list_view(inputs)
});